import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2PaginationModule } from "ng2-pagination";
import { SharedModule } from "../shared/shared.module";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { CustomFormsModule } from "ng2-validation/dist";
import { FormHelperService } from "../core/services/form-helper.service";
import { BrandPreidComponent } from './brand-preid.component';
import { BrandPreidService } from './brand-preid.service';
import { Ng2AutoCompleteModule } from 'ng2-auto-complete';
import { VgCoreModule } from 'videogular2/core';
import { VgControlsModule } from 'videogular2/controls';
import { VgOverlayPlayModule } from 'videogular2/overlay-play';
import { VgBufferingModule } from 'videogular2/buffering';
import { BrandPreIdModalComponent } from './brand-preid-modal.component';

@NgModule({
    imports: [CommonModule, SharedModule, Ng2PaginationModule, FormsModule, ReactiveFormsModule, CustomFormsModule, Ng2AutoCompleteModule,
        VgCoreModule,
        VgControlsModule,
        VgOverlayPlayModule,
        VgBufferingModule],
    exports: [],
    declarations: [BrandPreidComponent, BrandPreIdModalComponent],
    providers: [FormHelperService, BrandPreidService],
})
export class BrandPreidModule { }


// WEBPACK FOOTER //
// ./src/app/brand-preid/brand-preid.module.ts